import { default as _91_46_46_46slug_93fMZglCv4yzMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/[...slug].vue?macro=true";
import { default as indexNvdn9lJrQPMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/auth/index.vue?macro=true";
import { default as indexspmMZJ62xeMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93xixft9WkD3Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93BDo8EyjES9Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_936DvqlQLI5PMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93FtWBMG1d9yMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/news/[slug].vue?macro=true";
import { default as organisationslDdskxNPgVMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsWOK0DQbbHYMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programskS7kx3nVUYMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as index26yCI3Kj0NMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/processes/index.vue?macro=true";
import { default as dungeon0lD5pDwJfKMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsVQvAs9DFz9Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/secret/index/inputs.vue?macro=true";
import { default as index3v1oujERK6Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/secret/index.vue?macro=true";
import { default as indexEs09DDzsxmMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataG6gnN4OussMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClass1LbKqkZiUFMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93p5bcieoN1jMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexRjPwtRBQGFMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataWNphdr5VNKMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsiy01MmwY5jMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsGEwI9nPhe1Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights9fPn9nwZd7Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_937bKgH8eI7IMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexFAyRTSABAyMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesYn3jRWjc1oMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatamZJxKKGrhvMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_935j7VTYUxMmMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexGZMyqmalOoMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiese92U1yfi6eMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataGPC94mXaIaMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93C3rtbZUwxAMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexXIaq8lI29AMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataexhTks9NZ8Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93qkioqs0UzgMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexSdnBKjqUfmMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataEfJrIkOOq3Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClasselRNojYUi7Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsA25u3T70RZMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93OKReffKcpcMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexYeVDx5ccDpMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesCHNvrHSateMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataAnkXGl1FtwMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsMn03PxM7AlMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as statisticSurveyRightsjzmJoUvo1zMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue?macro=true";
import { default as _91id_933pbDbIVwbuMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexOnduQ8F59oMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesZ6WQdrTj3pMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseData77gdisYgvsMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsuvIME4ExGEMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93NAPKeDZ4nFMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexxzJjOU1Gp6Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDatapY0z1i66f5Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatauMcaA4ffQ4Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93J1JquuHyhdMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexf7SauxyRMhMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataouEiLWyKS9Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData.vue?macro=true";
import { default as _91id_936m8eIDZnbzMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexPh3J2VgaiSMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupskHz8baHKZ5Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatae4yOtpj32CMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93mAhlIgMBbvMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexAMgHYayHTPMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesMFUwDBsC1gMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesj0iMYajU8GMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupshh2EZW5FHKMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataUWgFhYCYIRMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconias8QoBcwp9XgMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesmPmsXvdGK8Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93D5yYV3SG6vMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as index0IKcMkg4mlMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsLAOKXh0POEMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltbrlY3hZnrZMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseData5FNqGlYofLMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsjpyMkLqIoJMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93vNWSm4kyflMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexB3dwS2Y3RgMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsi6qzlKi9UAMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesbs53gkWTnIMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatapXwoj9mWimMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93MtVK4KRikMMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/[id].vue?macro=true";
import { default as index1Hi6qBhqBbMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalilSsza5xH1Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93gtTgnqnEfZMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexxqjpbIzyBNMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviderscBmUanyzsPMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesOHIvy2YsbSMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsH82vAhFqgPMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatazZSZcY39IKMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategorieslyIvejOhThMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcept3ykOa8xzy1Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementXDYXW7AZ0dMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersr6SC5mUWqDMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_933MIIY8ZLNdMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indextiGUi6R86fMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsBSFCCa3xPMMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesxP8GR9MaXEMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatahBgla4j6X2Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersjFaPYfsrSYMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignaturekUqrgt3bkNMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93bGbcqblT2oMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id].vue?macro=true";
import { default as index6vKPRoqEggMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersRuScRPx9UkMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users.vue?macro=true";
import { default as settingslc8INhoUk1Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivities1TJ67DGNstMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataVjjwJPoLpgMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93HPTgi5YsU6Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as index3FQbwGSgpyMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceM9XL8pXuM4Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service.vue?macro=true";
import { default as languagemEftxSh32HMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataY3vh1nohDeMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories3GFpKvQ003Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreement0wNa4f1rxEMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersKRjnTHiBLKMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93xxWleaHzTZMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatakSIw4o40cgMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignature01fvRvKgduMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93gx4NQc0vchMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/[id].vue?macro=true";
import { default as indexBWehgKjPESMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/index.vue?macro=true";
import { default as settings13zGiZUnc2Meta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings.vue?macro=true";
import { default as signaturemRQXmXS3fiMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/signature.vue?macro=true";
import { default as sportbizzX58BL3WWtmMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93lsSnYZzhlmMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93mlezTxySWwMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexQzm9QmOV3NMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93LLqHJ7454rMeta } from "/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93fMZglCv4yzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexNvdn9lJrQPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexspmMZJ62xeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93xixft9WkD3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93BDo8EyjES9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_936DvqlQLI5PMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationslDdskxNPgVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: index26yCI3Kj0NMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceM9XL8pXuM4Meta?.name,
    path: "/service",
    meta: serviceM9XL8pXuM4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataouEiLWyKS9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexEs09DDzsxmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93p5bcieoN1jMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexRjPwtRBQGFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_937bKgH8eI7IMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexFAyRTSABAyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_935j7VTYUxMmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexGZMyqmalOoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93C3rtbZUwxAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexXIaq8lI29AMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93qkioqs0UzgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexSdnBKjqUfmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93OKReffKcpcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexYeVDx5ccDpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_933pbDbIVwbuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyRights",
    path: "statisticSurveyRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexOnduQ8F59oMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93NAPKeDZ4nFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsuvIME4ExGEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexxzJjOU1Gp6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93J1JquuHyhdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexf7SauxyRMhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_936m8eIDZnbzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesMFUwDBsC1gMeta?.name,
    path: "parishes",
    meta: parishesMFUwDBsC1gMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93mAhlIgMBbvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsLAOKXh0POEMeta?.name,
    path: "regions",
    meta: regionsLAOKXh0POEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93D5yYV3SG6vMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsi6qzlKi9UAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93vNWSm4kyflMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexB3dwS2Y3RgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93MtVK4KRikMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: index1Hi6qBhqBbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalilSsza5xH1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingslc8INhoUk1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviderscBmUanyzsPMeta?.name,
    path: "loginProviders",
    meta: loginProviderscBmUanyzsPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93gtTgnqnEfZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexxqjpbIzyBNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsBSFCCa3xPMMeta?.name,
    path: "organisations",
    meta: organisationsBSFCCa3xPMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_933MIIY8ZLNdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indextiGUi6R86fMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersRuScRPx9UkMeta?.name,
    path: "users",
    meta: usersRuScRPx9UkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93bGbcqblT2oMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: index6vKPRoqEggMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93HPTgi5YsU6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: index3FQbwGSgpyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings13zGiZUnc2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93xxWleaHzTZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93gx4NQc0vchMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexBWehgKjPESMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturemRQXmXS3fiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzX58BL3WWtmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93lsSnYZzhlmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93mlezTxySWwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexQzm9QmOV3NMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93LLqHJ7454rMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250710094151/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]